import React from 'react'
import { skillItem } from '../content/content'
import SkillCard from './SkillCard'

const Skill = () => {
    return (
        <section id='skill' className='section'>
            <div className="container">
                <h2 className="headline-2 reveal-up">
                    Essential Tools I use
                </h2>
                <p className="text-zinc-400 mt-3 mb-8 max-w-[50ch]">
                    Discover the powerful tools and technologies I use to create exceptional, high-performing websites & applications.
                </p>
                <div className="grid gap-3 grid-cols-[repeat(auto-fill,_minmax(250px,1fr))]">
                    {skillItem.map(({label, imgSrc, desc}, key)=>(
                        <SkillCard key={key} imgSrc={imgSrc} label={label} desc={desc} classes="reveal-up"/>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Skill